import React from "react";
import { observer, inject } from "mobx-react";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import { IAuthStore } from "Stores/Auth/types";
import { MenuIcon, MenuItemName, MenuSpan } from "./styles";
import { Values } from "@src/Tools/Values";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Brightness from "@material-ui/icons/Brightness2";
import PersonIcon from '@material-ui/icons/Person';
import LocationIcon from '@material-ui/icons/LocationOn';
import PositionIcon from '@material-ui/icons/BusinessCenter';
import Sunny from "@material-ui/icons/WbSunny";
import { RouterStore } from "mobx-react-router";
import { IValuesStore } from "@src/Stores/Values/types";
import { computed } from "mobx";
import { IManagementStore } from "@src/Stores/Management/types";
import { IThemesStore } from "@src/Stores/Themes/types";
import HandoverMenuItem from "../Handover/HandoverMenuItem";
import { common } from "@material-ui/core/colors";

interface IProps {
  onClose: () => void;
  anchorEl: HTMLElement;
  auth?: IAuthStore;
  values?: IValuesStore;
  routing?: RouterStore;
  management?: IManagementStore;
  themes?: IThemesStore;
}

@inject("auth", "routing", "values", "management", "themes")
@observer
class AccountMenu extends React.Component<IProps> {
  @computed get userLocation() {
    return this.props.auth.userLocation;
  }

  handleLogOut = async () => {
    try {
      await this.props.auth.logOut();
      this.props.routing.history.push("/login");
      window.location.reload(); // to force-reload page and clear react states and objects
    } catch (e) {
      console.error(e);
    }
  };

  backToUrl = () => {
    window.location.replace(this.props.auth.backUrl);
  };

  switchNightTheme = () => {
    this.props.values.toggleThemeVariant(true);
  };

  switchDayTheme = () => {
    this.props.values.toggleThemeVariant(false);
  };

  render() {
    return (
      <Menu
        id="menu-appbar"
        anchorEl={this.props.anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={true}
        onClose={this.props.onClose}
        >
        <MenuSpan>
            <MenuItemName disableRipple={true}>
            <ListItemIcon style={{ minWidth: 30 }}>
              <PersonIcon fontSize="small"/>
            </ListItemIcon>
              <Typography style={{ fontWeight: 600, color: `${common.black}`, fontSize: "0.875rem", whiteSpace: "nowrap" }}>
                {this.props.auth?.user?.person?.fullName}
              </Typography>
            </MenuItemName>
            <MenuItemName disableRipple={true}>
              <ListItemIcon style={{ minWidth: 30 }}>
                <PositionIcon fontSize="small"/>
              </ListItemIcon>
              <Typography style={{ color: `${common.black}`, fontSize: "0.875rem", whiteSpace: "nowrap" }}>
                {this.props.auth?.user?.position?.name}
              </Typography>
            </MenuItemName>
            {this.userLocation && (
              <MenuItemName disableRipple={true}>
                <ListItemIcon style={{ minWidth: 30 }}>
                    <LocationIcon fontSize="small"/>
                </ListItemIcon>
                <Typography style={{ color: `${common.black}`, fontSize: "0.875rem", whiteSpace: "nowrap" }}>{this.userLocation}</Typography>
              </MenuItemName>
            )}
        </MenuSpan>
        {this.props.values.isNightTheme ? (
          <MenuItem onClick={this.switchDayTheme}>
            <MenuIcon>
              <Sunny fontSize="small"/>
            </MenuIcon>
            <Typography variant="inherit">{Values.getLocalizationValue("dayTheme")}</Typography>
          </MenuItem>
        ) : (
          <MenuItem onClick={this.switchNightTheme}>
            <MenuIcon>
              <Brightness fontSize="small"/>
            </MenuIcon>
            <Typography variant="inherit">{Values.getLocalizationValue("nightTheme")}</Typography>
          </MenuItem>
        )}
        {this.props.auth.backUrl && (
          <MenuItem onClick={this.backToUrl}>
            <MenuIcon>
              <ArrowBack fontSize="small"/>
            </MenuIcon>
            <Typography variant="inherit">{Values.getLocalizationValue("back")}</Typography>
          </MenuItem>
        )}
        <HandoverMenuItem />
        <MenuItem onClick={this.handleLogOut}>
            <MenuIcon>
              <ExitToApp fontSize="small"/>
            </MenuIcon>
          <Typography variant="inherit">{Values.getLocalizationValue("signOut")}</Typography>
        </MenuItem>
      </Menu>
    );
  }
}

export default AccountMenu;
